<template>
  <div class="w-100">
    <PwaBlob v-if="isOnline" />
    <router-view></router-view>
    <v-container>
      <v-row class="flex justify-center ma-0 mt-5">
        <v-col :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
          <v-text-field
            v-model="search"
            label="Vad letar du efter?"
            solo
            filled
            @keydown="sendSearch"
          >
            <template v-slot:append-outer>
              <div style="transform: translateY(-12px);">
                <v-btn color="primary" fab dark @click="sendSearch">
                  <v-icon>
                    mdi-magnify
                  </v-icon>
                </v-btn>
              </div>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row class="mb-5">
        <v-col cols="12">
          <PwaBlobSmallScreen v-if="isOnline" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <CategoriesButtons :categories="categories" />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-for="species in featuredSpecies"
          :key="species.id"
          :cols="$_colsWidth"
          class="d-flex child-flex"
        >
          <SpeciesCard class="" :species="species" />
        </v-col>
      </v-row>
    </v-container>

    <BandAlien />
    <BandRed />
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */

import BandAlien from '@/components/BandAlien.vue'
import BandRed from '@/components/BandRed.vue'
import CategoriesButtons from '@/components/CategoriesButtons.vue'
import SpeciesCard from '@/components/SpeciesCard.vue'
import Setup from '@/mixins/Setup.js'
import Misc from '@/mixins/Misc.js'
import PwaBlob from '@/components/PwaBlob'
import PwaBlobSmallScreen from '@/components/PwaBlobSmallScreen'

export default {
  name: 'Home',
  components: {
    BandAlien,
    BandRed,
    CategoriesButtons,
    SpeciesCard,
    PwaBlob,
    PwaBlobSmallScreen
  },
  mixins: [Setup, Misc],
  data() {
    return {
      search: ''
    }
  },
  created() {},
  mounted() {
    this.$store.dispatch('setGeneralArea', 'all')
  },
  computed: {
    featuredSpecies() {
      return this.$store.getters.getFeaturedSpecies
    },
    categories() {
      return this.$store.state.categories
    }
  },
  methods: {
    setup() {},
    sendSearch(e) {
      if (e.type === 'keydown') {
        if (e.key === 'Enter') {
          this.$router.push({ name: 'Search', query: { q: this.search } })
        }
      } else {
        this.$router.push({ name: 'Search', query: { q: this.search } })
      }
    }
  }
}
</script>

<style scoped></style>
